<template>
  <div class="box">
    <h2 class="title is-4">Vérification d’un destinataire Peppol</h2>

    <div class="field">
      <label class="label">Nom ou numéro de TVA</label>
      <div class="control">
        <input
          v-model="query"
          class="input"
          placeholder="Ex. BE0123456789 ou Nom de société"
        />
      </div>
    </div>

    <div class="buttons">
      <button
        class="button is-primary"
        @click="searchRecipient"
        :disabled="loading"
      >
        Rechercher
      </button>
      <button
        class="button is-link"
        @click="verifyRecipient"
        :disabled="loading"
      >
        Vérifier adresse directe
      </button>
    </div>

    <div v-if="loading" class="mt-3">Recherche en cours...</div>

    <div v-if="result" class="mt-4">
      <pre>{{ result }}</pre>
    </div>
  </div>
</template>

<script>
import api from '@/utils/axios';

export default {
  name: 'PeppolVerify',
  data() {
    return {
      query: '',
      loading: false,
      result: null,
    };
  },
  methods: {
    async searchRecipient() {
      this.loading = true;
      try {
        const res = await api.post('/peppol/search-directory/', {
          query: this.query,
        });
        this.result = res.data;
      } catch (err) {
        console.error(err);
        this.result = { error: 'Erreur de recherche' };
      } finally {
        this.loading = false;
      }
    },
    async verifyRecipient() {
      this.loading = true;
      try {
        const res = await api.post('/peppol/verify/', {
          peppolAddress: this.query,
        });
        this.result = res.data;
      } catch (err) {
        console.error(err);
        this.result = { error: 'Erreur de vérification' };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
pre {
  background: #f8f8f8;
  padding: 1rem;
  border-radius: 6px;
}
</style>
